import { useEffect } from 'react'
import { Spinner } from '@heroui/react'
import { StationPanelLinePhoto } from '../panels/StationPanelLinePhoto'
import { WindRoseHeader } from './shared/WindRoseHeader'
import { WindRoseTable } from './shared/WindRoseTable'
import { WindRoseChart } from './shared/WindRoseChart'
import { useYearPeriodStore } from '../../store/useYearPeriodStore'
import { useWindRoseStore } from '../../store/useWindRoseStore'
import { useWindRoseData, calcYearFromTo } from '../../hooks/useWindRoseData'

export function YlyVitrRuziceView({ station }) {
  const { year, setYear } = useYearPeriodStore()
  const { vtype, intervals } = useWindRoseStore()

  // Roční růžice se počítá až nad kompletním rokem — aktuální rok není volitelný,
  // ale store je sdílený s ostatními reporty, takže hodnotu srazíme na loňský rok.
  const maxYear = new Date().getFullYear() - 1
  useEffect(() => {
    if (year > maxYear) setYear(maxYear)
  }, [year, maxYear, setYear])

  const effYear = Math.min(year, maxYear)

  const { data, loading, error } = useWindRoseData({
    ghId: station?.gh_id, year: effYear, stype: 'YEAR', sid: 'YEAR', vtype, intervals,
  })

  const { from, to } = calcYearFromTo(effYear)

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b border-gray-200 bg-white flex flex-col gap-3">
        {station && <StationPanelLinePhoto station={station} />}
        <WindRoseHeader stype="YEAR" year={effYear} onYearChange={setYear} />
      </div>

      <div className="flex-1 min-h-0 p-4 flex flex-col gap-4 overflow-auto">
        {loading && (
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Spinner size="sm" /> Načítání dat…
          </div>
        )}
        {error && <p className="text-red-500 text-sm">Chyba při načítání dat</p>}
        {!loading && !error && !data && (
          <p className="text-gray-500 text-sm">Pro toto období nejsou data k dispozici</p>
        )}
        {!loading && !error && data && (
          <>
            <WindRoseTable data={data} vtype={vtype} />
            <WindRoseChart station={station} stype="YEAR" from={from} to={to} vtype={vtype} intervals={intervals} />
          </>
        )}
      </div>
    </div>
  )
}
